/* src/app/quickbooks/access-revoked/access-revoked.component.scss */
/*# sourceMappingURL=access-revoked.component.css.map */
